import { Component, Input } from '@angular/core';
import { OptionalMemberService } from '../../cart-process/optional-member.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { GlobalOffersMessages } from '../../interfaces/cart-details.interface';

@Component({
  selector: '[new-offer-slot-add-optional-member]',
  templateUrl: './new-offer-slot-add-optional-member.component.html',
  styles: [':host b {font-weight: normal}']
})
export class NewOfferSlotAddOptionalMemberComponent {
  @Input() public messages: GlobalOffersMessages;
  @Input() public isMessageVisible: boolean;

  public model: any;
  public isVirginBrand: boolean;

  constructor(
    public commonInfo: CommonInfoService,
    private optionalMemberService: OptionalMemberService,
  ) {
    this.model = this.optionalMemberService.model;
    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  public addNewSlot($event: Event): void {
    $event.preventDefault();

    this.optionalMemberService.addNewSlot();
  }
}
